const headerStats = [
  {
    label: 'Number of courses',
    value: 1157,
  },
  {
    label: 'Number of programs',
    value: 47,
  },
  {
    label: 'Number of Sections',
    value: 2371,
  },
  {
    label: 'SCH 1-year growth',
    value: '+4.5%',
  },
  {
    label: 'Total attempted SCH',
    value: 2527,
  },
]

const colors = [ '#007bff', '#e6c722', '#ff995c', '#7de1d9', '#70bef2', '#ffb27e', '#37a976', '#007e9f' ]
const alphaColors = [ 'rgba(0, 123, 255, 0.5)', 'rgba(230, 199, 34, 0.5)' ]

const growthStudentCreditHours = {
  datasets: {
    labels: [ 'Winter 2020', 'Spring 2020', 'Summer 2020', 'Fall 2020', 'Winter 2021', 'Spring 2021', 'Summer 2021' ],
    datasets: [ {
      label: 'Assignment time',
      data: [ 10, -5, -3, 5, 8, 6, -10 ],
      backgroundColor: 'transparent',
      borderColor: colors[0],
      borderWidth: 4,
      pointBackgroundColor: colors[0],
    },
    {
      label: 'Lecture time',
      data: [ 8, -2, -1, 2, 6, 3, -7 ],
      backgroundColor: 'transparent',
      borderColor: colors[1],
      borderWidth: 4,
      pointBackgroundColor: colors[1],
    } ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            callback: function (label, index, labels) { // Formatting Y axis scale points
              return `${label}%`
            },
          },
          gridLines: {
            display: false,
            // color: '#F1F1F1',
            // zeroLineColor: '#FFFFFF',
            // drawTicks: true,
            // drawBorder: false,
            // offset: true,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
    },
  },
}

const attemptedStudentCreditHours = {
  datasets: {
    labels: [ '2010-2011', '2011-2012', '2012-2013', '2013-2014', '2014-2015', '2015-2016', '2016-2017', '2017-2018', '2018-2019', '2019-2020', '2020-2021' ],
    datasets: [
      {
        label: 'Lower Division',
        data: [ 2800, 2500, 2300, 3200, 3300, 3100, 3000, 2800, 2500, 2300, 3200, 3300, 3100, 3000 ],
        backgroundColor: colors[0],
      },
      {
        label: 'Upper Division',
        data: [ 280, 250, 230, 320, 330, 360, 300, 280, 250, 230, 320, 330, 360, 300 ],
        backgroundColor: colors[1],
      },
      {
        label: 'Graduate',
        data: [ 680, 210, 230, 122, 345, 324, 567, 122, 323, 332, 123, 324, 433, 121 ],
        backgroundColor: colors[2],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: 'Total Attempted Credit Hours',
          },
        },
      ],
      xAxes: [
        {
          stacked: true,
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
    },
  },
}

const trendsMedianClassSizeCapacity = {
  datasets: {
    labels: [ '2013-2014', '2014-2015', '2015-2016', '2016-2017' ],
    datasets: [
      {
        label: 'Median Class Size',
        data: [ 31, 15, 23, 25 ],
        backgroundColor: alphaColors[0],
        borderColor: colors[0],
        borderWidth: 4,
        pointBackgroundColor: colors[0],
      },
      {
        label: 'Median Class Capacity',
        data: [ 34, 18, 25, 28 ],
        backgroundColor: alphaColors[1],
        borderColor: colors[1],
        borderWidth: 4,
        pointBackgroundColor: colors[1],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
    },
  },
}

const medianClassSizeCapacityCourseType = {
  datasets: {
    labels: [ 'Lecture', 'Practicum', 'Seminar', 'Thesis' ],
    datasets: [
      {
        label: 'Median Class Size',
        data: [ 30, 15, 10, 7 ],
        backgroundColor: colors[0],
      },
      {
        label: 'Median Class Capacity',
        data: [ 36, 20, 15, 10 ],
        backgroundColor: colors[1],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
    },
  },
}

const distributionSectionFillRatesByTerm = {
  datasets: {
    labels: [ 'Below 25%', 'Between 25-49%', 'Between 50-59%', 'Between 60-69%', 'Between 70-79%', 'Between 80-89%', 'Between 90-99%', 'Between 100% or Above' ],
    datasets: [
      {
        label: 'Fall',
        data: [ 4, 7, 3, 9, 5, 4, 6, 10 ],
        backgroundColor: colors[0],
      },
      {
        label: 'Spring',
        data: [ 2, 10, 2, 0, 4, 0, 5, 14 ],
        backgroundColor: colors[1],
      },
      {
        label: 'Summer',
        data: [ 0, 7, 3, 6, 0, 4, 4, 6 ],
        backgroundColor: colors[2],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: 'Count of Distinct Sections',
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: 'Section Fill Rate',
          },
        },
      ],
    },
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
    },
  },
}

const trendsSectionConsolidationOpportunities = {
  datasets: {
    labels: [ '2013-2014', '2014-2015', '2015-2016', '2016-2017' ],
    datasets: [
      {
        label: 'Number of Necessary Sections',
        data: [ 46, 63, 62, 70 ],
        backgroundColor: alphaColors[0],
        borderColor: colors[0],
        borderWidth: 4,
        pointBackgroundColor: colors[0],
      },
      {
        label: 'Number of Collapsible Sections',
        data: [ 48, 67, 68, 58 ],
        backgroundColor: alphaColors[1],
        borderColor: colors[1],
        borderWidth: 4,
        pointBackgroundColor: colors[1],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
    },
  },
}

const topCoursesSectionConsolidationOpportunities = {
  datasets: {
    labels: [ 'MKTG311', 'MKTG402', 'MKTG407', 'MKTG450', 'MKTG490', 'MKTG617', 'MKTG895' ],
    datasets: [
      {
        label: 'Number of Necessary Sections',
        data: [ 26, 6, 3, 1, 2, 1, 1 ],
        backgroundColor: colors[0],
      },
      {
        label: 'Number of Collapsible Sections',
        data: [ 1, 1, 1, 1, 1, 1, 1 ],
        backgroundColor: colors[1],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
        },
      ],
      xAxes: [
        {
          stacked: true,
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
    },
  },
}

const bottleneckCoursesByCourseDivision = {
  datasets: {
    labels: [ 'Upper Division', 'Graduate' ],
    datasets: [
      {
        label: 'Fall',
        data: [ 1, 1 ],
        backgroundColor: colors[0],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: '# of Courses w/Fill Rate >= 90%',
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: false,
    },
  },
}

const departmentGrowthPlanning = {
  datasets: {
    datasets: [
      {
        label: 'Department Growth Planning',
        data: [
          {
            x: 100,
            y: 10,
            r: 80,
          }, {
            x: 60,
            y: -5,
            r: 50,
          },
          {
            x: 100,
            y: -18,
            r: 30,
          },
          {
            x: 40,
            y: -1,
            r: 5,
          },
        ],
        backgroundColor: colors[0],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      // padding: 50,
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            callback: function (label, index, labels) {
              return `${label}%`
            },
          },
          gridLines: {
            color: '#F1F1F1',
            zeroLineColor: '#ccc',
            drawTicks: true,
            drawBorder: false,
            offset: true,
          },
          scaleLabel: {
            display: true,
            labelString: 'Attempted Credits [% Prev Year]',
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            color: '#F1F1F1',
            zeroLineColor: '#FFFFFF',
            drawTicks: true,
            drawBorder: false,
            offset: true,
          },
          ticks: {
            beginAtZero: true,
            callback: function (label, index, labels) {
              return `${label}%`
            },
          },
        },
      ],
    },
    legend: {
      display: false,
    },
  },
}

const instructionalHeadcount = {
  datasets: {
    labels: [ 'Tenured', 'On Track', 'Adjunct' ],
    datasets: [
      {
        data: [ 7, 2, 13 ],
        backgroundColor: colors[0],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: 'Number of Instructional Staff',
          },
        },
      ],
      xAxes: [
        {
          stacked: true,
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: false,
    },
  },
}

const instructionalTrendHeadcount = {
  datasets: {
    labels: [ '2013-2014', '2014-2015', '2015-2016', '2016-2017' ],
    datasets: [
      {
        label: 'Adjunct',
        data: [ 9, 11, 10, 13 ],
        backgroundColor: 'transparent',
        borderColor: colors[0],
        borderWidth: 4,
        pointBackgroundColor: colors[0],
      },
      {
        label: 'Tenured',
        data: [ 7, 6, 7, 7 ],
        backgroundColor: 'transparent',
        borderColor: colors[1],
        borderWidth: 4,
        pointBackgroundColor: colors[1],
      },
      {
        label: 'On track',
        data: [ 1, 1, 1, 2 ],
        backgroundColor: 'transparent',
        borderColor: colors[2],
        borderWidth: 4,
        pointBackgroundColor: colors[2],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            labelString: 'Number of Instrutional Staff',
          },
          gridLines: {
            display: false,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
    },
  },
}

const IFTEStaff = {
  datasets: {
    labels: [ 'Tenured', 'On Track', 'Adjunct' ],
    datasets: [
      {
        data: [ 4.1, 2.0, 5.4 ],
        backgroundColor: colors[0],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: 'Total IFTE',
          },
        },
      ],
      xAxes: [
        {
          stacked: true,
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: 'IFTE = Total credits hours taught per staff/Full-time instructional load (24)',
          },
        },
      ],
    },
    legend: {
      display: false,
    },
  },
}

const irendsIFTEStaff = {
  datasets: {
    labels: [ '2013-2014', '2014-2015', '2015-2016', '2016-2017' ],
    datasets: [
      {
        label: 'Adjunct',
        data: [ 6.0, 5.1, 6.6, 5.4 ],
        backgroundColor: 'transparent',
        borderColor: colors[0],
        borderWidth: 4,
        pointBackgroundColor: colors[0],
      },
      {
        label: 'Tenured',
        data: [ 4.1, 3.6, 4.1, 4.1 ],
        backgroundColor: 'transparent',
        borderColor: colors[1],
        borderWidth: 4,
        pointBackgroundColor: colors[1],
      },
      {
        label: 'On track',
        data: [ 0.5, 0.5, 0.5, 2.0 ],
        backgroundColor: 'transparent',
        borderColor: colors[2],
        borderWidth: 4,
        pointBackgroundColor: colors[2],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            labelString: 'Total IFTE',
          },
          gridLines: {
            display: false,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
    },
  },
}

const totalMomentum = {
  datasets: [
    {
      labels: [ 'Momentum Year Complete', 'Momentum Year Hours', 'Pathway Progress', 'Math Gateway', 'English Gateway' ],
      datasets: [
        {
          data: [ 23, 60, 45, 79, 30 ],
          backgroundColor: colors,
        },
      ],
    },
    {
      labels: [ 'Momentum Year Complete', 'Momentum Year Hours', 'Pathway Progress', 'Math Gateway', 'English Gateway' ],
      datasets: [
        {
          data: [ 55, 59, 52, 70, 43 ],
          backgroundColor: colors,
        },
      ],
    },
    {
      labels: [ 'Momentum Year Complete', 'Momentum Year Hours', 'Pathway Progress', 'Math Gateway', 'English Gateway' ],
      datasets: [
        {
          data: [ 12, 30, 84, 25, 77 ],
          backgroundColor: colors,
        },
      ],
    },
    {
      labels: [ 'Momentum Year Complete', 'Momentum Year Hours', 'Pathway Progress', 'Math Gateway', 'English Gateway' ],
      datasets: [
        {
          data: [ 77, 25, 99, 30, 12 ],
          backgroundColor: colors,
        },
      ],
    },
    {
      labels: [ 'Momentum Year Complete', 'Momentum Year Hours', 'Pathway Progress', 'Math Gateway', 'English Gateway' ],
      datasets: [
        {
          data: [ 66, 45, 60, 60, 30 ],
          backgroundColor: colors,
        },
      ],
    },
    {
      labels: [ 'Momentum Year Complete', 'Momentum Year Hours', 'Pathway Progress', 'Math Gateway', 'English Gateway' ],
      datasets: [
        {
          data: [ 65, 55, 70, 50, 28 ],
          backgroundColor: colors,
        },
      ],
    },
    {
      labels: [ 'Momentum Year Complete', 'Momentum Year Hours', 'Pathway Progress', 'Math Gateway', 'English Gateway' ],
      datasets: [
        {
          data: [ 62, 62, 77, 48, 25 ],
          backgroundColor: colors,
        },
      ],
    },
  ],
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          stacked: false,
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
        },
      ],
      xAxes: [
        {
          stacked: false,
          gridLines: {
            display: false,
          },
          ticks: {
            beginAtZero: true,
            callback: function (label, index, labels) { // Formatting Y axis scale points
              return `${label}%`
            },
          },
        },
      ],
    },
    legend: {
      display: false,
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          const dataset = data.datasets[tooltipItem.datasetIndex]
          const currentValue = dataset.data[tooltipItem.index]
          return `${currentValue}%`
        },
      },
    },
  },
}

const historicalMomentum = {
  datasets: {
    labels: [ 'Winter 2020', 'Spring 2020', 'Summer 2020', 'Fall 2020', 'Winter 2021', 'Spring 2021', 'Summer 2021' ],
    datasets: [
      {
        label: 'Momentum Year Complete',
        data: [ 50, 55, 48, 58, 66, 65, 62 ],
        backgroundColor: 'transparent',
        borderColor: colors[0],
        borderWidth: 4,
        pointBackgroundColor: colors[0],
      },
      {
        label: 'Momentum Year Hours',
        data: [ 60, 59, 40, 35, 45, 55, 62 ],
        backgroundColor: 'transparent',
        borderColor: colors[1],
        borderWidth: 4,
        pointBackgroundColor: colors[1],
      },
      {
        label: 'Pathway Progress',
        data: [ 45, 52, 55, 59, 60, 70, 77 ],
        backgroundColor: 'transparent',
        borderColor: colors[2],
        borderWidth: 4,
        pointBackgroundColor: colors[2],
      },
      {
        label: 'Math Gateway',
        data: [ 79, 70, 78, 65, 60, 50, 48 ],
        backgroundColor: 'transparent',
        borderColor: colors[3],
        borderWidth: 4,
        pointBackgroundColor: colors[3],
      },
      {
        label: 'English Gateway',
        data: [ 50, 43, 38, 44, 30, 28, 25 ],
        backgroundColor: 'transparent',
        borderColor: colors[4],
        borderWidth: 4,
        pointBackgroundColor: colors[4],
      },
    ],
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            callback: function (label, index, labels) { // Formatting Y axis scale points
              return `${label}%`
            },
          },
          gridLines: {
            display: false,
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: false,
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          const dataset = data.datasets[tooltipItem.datasetIndex]
          const currentValue = dataset.data[tooltipItem.index]
          const currentLabel = dataset.label
          return `${currentLabel}: ${currentValue}%`
        },
      },
    },
  },
}

export default {
  headerStats,
  colors,
  growthStudentCreditHours,
  attemptedStudentCreditHours,
  trendsMedianClassSizeCapacity,
  medianClassSizeCapacityCourseType,
  distributionSectionFillRatesByTerm,
  trendsSectionConsolidationOpportunities,
  topCoursesSectionConsolidationOpportunities,
  bottleneckCoursesByCourseDivision,
  departmentGrowthPlanning,
  instructionalHeadcount,
  instructionalTrendHeadcount,
  IFTEStaff,
  irendsIFTEStaff,
  totalMomentum,
  historicalMomentum,
}
